import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { toggleExportingPdf, updatePdfStatus } from '@/store/actions'
import {
  getLanguageCode,
  getLanguageKeys,
  getMagazine,
  getExportingPdf,
  getExportedPdfs,
  getUser,
  getPages,
  getTranslation,
} from '@/store/getters'
import { getFormatedDate, buildPdfHtmlTemplate } from '@/constants'
import { MagazinesResource } from '@/resources'
import { makeCancelable } from '@/utils/cancelablePromise'
import { regexName } from '@/components/commons/editor/configs/Comoons'

import styles from './styles.scss'

/** Components */
import { rawElementFactory } from '@/components/commons/editor/EditorFactory'
import Modal from '@/components/Modal'
import { LoaderComponent } from '@/components/commons/LoaderComponent'
import IconComponent from '@/components/commons/IconComponent'
import { PopOver } from '@/components/commons/PopOver'
import { pageSizeFromMagazine, getPdfExportConfig } from "../../../../utils/pageSize";

class ExportMagazine extends Component {
  constructor(props) {
    super(props)

    const pageSize = pageSizeFromMagazine(props.magazine)
    const pdfExportConfig = getPdfExportConfig(pageSize)

    this.pdfExportConfig = pdfExportConfig
    this.scaleFactor = pdfExportConfig.scaleFactor
    this.state = {
      showExported: false,
      showWarningPDF: false,
      pageProps: {
        width: pdfExportConfig.exportWidthPx,
        height: pdfExportConfig.exportHeightPx
      }
    }
    this.pagesToPrint = []
    this.prepareAndSaveHTML = this.prepareAndSaveHTML.bind(this)
    this.gotoUrl = this.gotoUrl.bind(this)
    this.getPagesPromise = null
  }

  componentWillUnmount() {
    if (this.getPagesPromise) {
      this.getPagesPromise.cancel()
    }
  }

  /**
   * ON MOUT CHECK PAGES
   * AND START PROCCESS
   */
  handleStartProcess = () => {
    const { magazine } = this.props

    this.pagesToPrint.length = 0
    this.getPagesPromise = makeCancelable(
      MagazinesResource.getPages(magazine.id)
    )
    this.getPagesPromise.promise.then(({ data }) => {
      if (data.length) {
        this.createPages(data, false)
      }
    })
  }

  /**
   * PREPARE REQ
   */
  prepareAndSaveHTML = () => {
    const { magazine, toggleExportingPdf, user } = this.props

    const styles = Array.from(
      document.querySelectorAll('link[class="google-fonts"]')
    )
    const headerContent = styles.map(link => link.outerHTML).join('')
    const body = this.pagesToPrint.join('')
    const { pageSizeMm } = this.pdfExportConfig
    const _html = buildPdfHtmlTemplate(pageSizeMm.width, pageSizeMm.height)
      .replace('$$styles', headerContent)
      .replace('$$pages', body)
	const magazineName = regexName(magazine.title)

    toggleExportingPdf({
      exporting: true,
      content: _html,
      magazineId: magazine.id,
      magazineName: (magazineName ? magazineName : 'untitled'),
      userId: user.id_usuario,
      pageWidth: pageSizeMm.width,
      pageHeight: pageSizeMm.height,
    })
  }

  /**
   * CREATE THE PAGES
   * @param {Array} pages
   */
  createPages = (pages) => {
    if (!pages.length) {
      this.prepareAndSaveHTML()
      return
    }

    const { pageProps } = this.state
    const pageIdentifier = (this.props.pages.length - pages.length) + 1
    const page = pages.shift()
    const html = page.items
      .map(item => {
        const { content } = item
        const parsed =
          typeof content === 'string' ? JSON.parse(content) : content
        return rawElementFactory(parsed, this.scaleFactor, true, 'pdf')
      })
      .join('')

    const properties =
      typeof page.properties === 'string'
        ? page.properties === 'null'
          ? { backgroundColor: '#fff' }
          : JSON.parse(page.properties)
        : !page.properties || { backgroundColor: '#fff' }

    this.setState({
      pageProps: {
        ...pageProps,
        ...properties
      }
    })

    /**
     * BACKGROUND FROM PAGE
     */
    let background
    if (typeof properties.backgroundImage !== 'undefined') {
      background = `background-image: ${properties.backgroundImage
        }; background-size: ${properties.backgroundSize};`
    } else {
      background = `background-color: ${properties.backgroundColor};`
    }

    const pageContainer = `<div style="display: block; ${background} width: ${pageProps.width
      }px; height: ${pageProps.height
      }px; overflow: hidden; position: relative; page-break-after: always;"><a name="page-${pageIdentifier}"></a> ${html}</div>`

    this.pagesToPrint.push(pageContainer)
    this.createPages(pages, true)
  }

  gotoUrl({ date, magazine_id }) {
    this.props.updatePdfStatus({
      id: magazine_id,
      date
    })
  }

  render() {
    const { localeCode, locales, isExportingPDF, exporteds, user, translation } = this.props
    const { showExported, showWarningPDF } = this.state
    const list = [...exporteds].splice(0, 2)

    return (
      <div className={styles['wraper-magazine-export']}>
        <div className={styles['wraper-magazine-export__button']}>
          <Link
            to="#"
            disabled={isExportingPDF}
            ba-tooltip-title={translation('action-generate-pdf')}
            ba-tooltip-position='bottom'
            ba-tooltip-color='dark'
            className='ba-btn ba-btn-add ba-sm ba-rounded'
            onClick={() => { this.setState({ showWarningPDF: true }) }}
          >
            <span>
              {!isExportingPDF
                ? <builderall-icon code='7535'></builderall-icon>
                : <LoaderComponent size="la-sm" />
              }
            </span>
          </Link>
          <span
            className={styles['wraper-magazine-export__button-pdfs']}
            onClick={() => this.setState({ showExported: true })}
            aria-hidden={true}
            ba-tooltip-title={translation('action-list-pdf')}
            ba-tooltip-position='bottom'
            ba-tooltip-color='dark'
          >
            <IconComponent icon="caret-down" />
          </span>
          {showExported && (
            <PopOver
              className={styles['wraper-magazine-export__exporteds']}
              hidePopover={() => this.setState({ showExported: false })}
            >
              {/* <h3>{translation('magazine-already-exported')}</h3> */}
              <ul>
                {list.map((item, index) => (
                  <li key={index}>
                    <a
                      onClick={() => this.gotoUrl(item)}
                      href={`${process.env.REACT_APP_API_URL}/${item.path}`}
                      target="blank"
                    >
                      {`${item.name} - ${getFormatedDate(item.date, false, localeCode)}`}
                    </a>
                  </li>
                ))}
              </ul>
              <div className={styles['wraper-magazine-export__all-exporteds']}>
                <Link
                  to={`/exported-magazines/${user.id_usuario}`}
                  data-ba-i="magazine-list-pdfs"
                >
                  {translation('magazine-view-all-exported')}
                </Link>
              </div>
            </PopOver>
          )}
        </div>
        <Modal
          show={showWarningPDF}
        >
          <div className={`ba-card ${styles['ba-modal-card']}`}>
            <div class={`ba-toast ba-alert ba-w-100 ${styles['ba-modal-card__title']}`}>
              <div class="ba-toast-alert">
                <div class="ba-left">
                  <span class="ba-icon"></span>
                  <span class="ba-text ba-montserrat-700">{locales['pdf-warning']}</span>
                </div>
              </div>
            </div>
            <span class='ba-description'>
              {locales['pdf-warning-message']}
            </span>
            <div className="ba-content ba-w-100">
              <div className='ba-flex ba-w-100'>
                <button className='ba-btn ba-md ba-light ba-w-50'
                  onClick={() => this.setState({ showWarningPDF: false })}>
                  {translation('general-cancel')}
                </button>

                <button className='ba-btn ba-md ba-orange ba-mg-l-1 ba-w-50'
                  onClick={() => this.setState({ showWarningPDF: false }, this.handleStartProcess)}>
                  {translation('general-confirm')}
                </button>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    )
  }
}
const mapStatesToProps = state => {
  const localeCode = getLanguageCode(state)
  const locales = getLanguageKeys(state)
  const magazine = getMagazine(state)
  const pages = getPages(state)
  const isExportingPDF = getExportingPdf(state)
  const exporteds = getExportedPdfs(state)
  const user = getUser(state).user
  const translation = getTranslation(state)
  return {
    localeCode,
    locales,
    magazine,
    pages,
    isExportingPDF,
    exporteds,
    user,
    translation
  }
}
export default connect(
  mapStatesToProps,
  { toggleExportingPdf, updatePdfStatus }
)(ExportMagazine)



// WEBPACK FOOTER //
// ./src/components/Heade/components/ExportMagazine/index.js